module.exports = window.L = require('leaflet/dist/leaflet-src');



//////////////////
// WEBPACK FOOTER
// ./~/mapbox.js/src/leaflet.js
// module id = 836
// module chunks = 0